import {get, post} from "@/config/api";

const state = {
  userInfo: {},
  WxLoginAk: "",
};

const getters = {
  getAkWxLogin(state) {
    if (state.WxLoginAk) {
      return state.WxLoginAk
    }
    let ak = window.$cookies.get("wx_login_ak")
    if (ak) {
      return ak
    }
    return ""
  },
};

const mutations = {
};

const actions = {
  CacheAccountInfoMine({}, params) {
    return new Promise((resolve, reject) => {
      let userInfo = state.userInfo;
      if (userInfo && userInfo.id) {
        resolve(userInfo)
      } else {
        get("v2/account/mine/", params).then((data) => {
          if (data.code === 0) {
            state.userInfo = data.data
            resolve(data.data)
          } else {
            resolve({})
          }
        }, (err) => {
          reject(err)
        })
      }
    })
  },

  LogoutAccount({}, params) {
    return new Promise((resolve, reject) => {
      get("account/logout_account", params).then((data) => {
        state.userInfo = {}
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  UpdateAccountMine({}, params) {
    return new Promise((resolve, reject) => {
      post("account/update/mine/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  AccountInfoMine({}, params) {
    return new Promise((resolve, reject) => {
      get("v2/account/mine/", params).then((data) => {
        if (data.code === 0) {
          state.userInfo = data.data
        }
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  OauthLoginUnion({}, params) {
    return new Promise((resolve, reject) => {
      post("account/oauth/login_union/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  SendSms({}, params) {
    return new Promise((resolve, reject) => {
      post("account/login_sms_send/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  LoginSms({}, params) {
    return new Promise((resolve, reject) => {
      post("account/login_sms/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  SetAkWxLogin({}, ak) {
    state.WxLoginAk = ak
    window.$cookies.set("wx_login_ak", "" + ak)
  },

  WxOauthLoginCode({}, params) {
    return new Promise((resolve, reject) => {
      get("/v2/account/oauth/login_code/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  OauthLoginStatus({}, params) {
    return new Promise((resolve, reject) => {
      get("/v2/account/oauth/login_status/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  AuthLoginAk({}, params) {
    return new Promise((resolve, reject) => {
      get(`/auth/auth_key_login/`, params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

  UserProfile({}, params) {
    return new Promise((resolve, reject) => {
      get(`/account/user/${params.id}/`, params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
